module.exports = __webpack_public_path__ + "img/-e-photo_01@2x.d4e34d6c.png";